import { Injectable } from '@angular/core';

export interface UserPermissions {
  canCreateClients: boolean;
  canCreateEvaluations: boolean;
  canCreateOnlyAffiliates: boolean;
  canCreateReports: boolean;
  canCreateTasks: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class CompanyPermissionsFactory {
  private readonly STORAGE_KEY = 'user_permissions';
  permissions: UserPermissions | null = null;
  constructor() { }

  savePermissions(permissions: UserPermissions): void {
    const json = JSON.stringify(permissions);
    const base64 = btoa(json);
    sessionStorage.setItem(this.STORAGE_KEY, base64);
  }

  getPermissions(): UserPermissions | null {
    const base64 = sessionStorage.getItem(this.STORAGE_KEY);
    if (!base64) return null;
    const json = atob(base64);
    return JSON.parse(json) as UserPermissions;
  }

  clearPermissions(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}
